import React, { Fragment } from 'react';
import classnames from 'classnames';
import useMediaQuery, { SCREEN_SIZES } from '../../hooks/useMediaQuery';
import Text from '../../atoms/text/Text';
import Badge from '../../atoms/badge/Badge';
import Dropdown from '../../atoms/dropdown/Dropdown';
import { BadgeProps } from '../../atoms/badge/Badge';
import Avatar, { AvatarProps } from '../../atoms/avatar/Avatar';
import { DropdownItemProps } from '../../atoms/dropdown/DropdownItem';

interface DropDownInfoProps {
  name?: string;
  email?: string;
}

export interface CardHeaderProps {
  testId?: string;
  avatar?: AvatarProps;
  title?: string;
  badge?: BadgeProps;
  description?: string;
  buttons?: JSX.Element[];
  dropDownInfo?: DropDownInfoProps;
  dropDownListItem?: DropdownItemProps[];
  className?: string;
  shadow?: boolean;
  portal?: boolean;
}

const CardHeader = ({
  testId,
  avatar,
  title,
  badge,
  description,
  buttons,
  dropDownInfo,
  dropDownListItem,
  className,
  shadow,
  portal,
}: CardHeaderProps) => {
  const mobileView = useMediaQuery(`(max-width: ${SCREEN_SIZES.MD})`);

  return (
    <div
      data-testid={testId}
      className={classnames(
        'd-flex',
        'bg-white',
        'py-10',
        {
          'flex-column gap-8 px-8': mobileView,
          'justify-content-between align-items-center px-12 gap-8': !mobileView,
          'shadow-xs': shadow,
        },
        className,
      )}
    >
      <div
        className={classnames('d-flex align-items-center w-100', {
          'justify-content-between': !mobileView,
          'flex-column gap-8': mobileView,
        })}
      >
        <div className="d-flex  align-items-center gap-8 w-100">
          {avatar && (
            <div className="m-auto">
              <Avatar {...avatar} />
            </div>
          )}

          <div
            className={classnames('d-flex justify-content-between w-100', {
              'align-items-center': mobileView,
            })}
          >
            <div
              className={classnames('d-flex flex-column flex-wrap gap-4', {
                'w-100': !mobileView,
              })}
            >
              <div className="d-flex">
                <Text weight="semibold" size="lg" color="dark">
                  {title}
                </Text>
                {badge && (
                  <div className="text-nowrap py-1 px-2">
                    <Badge {...badge} />
                  </div>
                )}
              </div>
              {description ? (
                <Text weight="normal" size="sm" color="subtitle1">
                  {description}
                </Text>
              ) : null}
            </div>

            {mobileView && (dropDownInfo || dropDownListItem) && (
              <Dropdown
                buttonType="icon"
                info={dropDownInfo}
                listItem={dropDownListItem}
                portal={portal}
              />
            )}
          </div>
        </div>

        <div
          className={classnames('d-flex flex-wrap w-100 gap-6', {
            'justify-content-end': !mobileView,
          })}
        >
          {buttons?.map((button, index) => (
            <Fragment key={index}>{button}</Fragment>
          ))}
        </div>
      </div>

      {!mobileView && (dropDownInfo || dropDownListItem) && (
        <Dropdown
          buttonType="icon"
          info={dropDownInfo}
          listItem={dropDownListItem}
          portal
        />
      )}
    </div>
  );
};

export default CardHeader;
